import messages from './CreerUtilisateur.json'
import BtnRetour from 'src/components/Dashboard/Layout/BtnRetour/BtnRetour.vue'

export default {
  name: 'CreerUtilisateur',
  i18n: messages,
  components: {
    BtnRetour,
  },

  props: {
    logged: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      // Formulaire
      form: {
        id: null,
        nom: null,
        prenom: null,
        mail: null,
        confirmMail: null,
        actif: true,
        admin: false,
        supprime: null,
        structure: null,
        fonction: null,
        datesPoste: null,
      },
      // Captcha
      recaptchaCheck: true,

      // Données reçues du back
      data: {
        structures: null,
        fonctions: null,
      },

      // Gestion IHM
      controls: {
        form: {
          login: {
            loading: false,
            available: null,
          },
          mail: {
            loading: false,
            available: null,
          },
          structureEnable: true,
          fonctionEnable: true,
        },
      },
    }
  },

  mounted() {
    if (this.logged) {
      this.fetchData()
    } else {
      // render captcha with site key in env var
      this.fetchStructuresRegister()
      window.grecaptcha.render('recaptcha', {
        'sitekey': process.env.VUE_APP_CAPTCHA_SITE_KEY,
        'theme': 'light'
      })
    }
  },

  methods: {
    /**
     * Récupération des données.
     *
     * De la structure de l'utilisateur courant, si id passé en paramétre
     * D'une structure données sinon
     */
    fetchData() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      let uri = this.$val.isDefined(this.$route.params.idStructure) ? 'rest/bd/structure/' + this.$route.params.idStructure : 'rest/bd/structure/user/me'
      this.$axios.get(uri).then(
        (response) => {
          if (Array.isArray(response.data)) {
            this.data.structures = response.data
            this.controls.form.fonctionEnable = false
            this.$eventHub.$emit(this.$eventHub.LOADING.END)
          } else {
            // 1 seul élement, sélectionné par defaut
            this.data.structures = new Array(response.data)
            this.form.structure = response.data.id
            this.fetchFonctions()
          }
        },
        (error) => {
          this.$notify.error({
            title: this.$t('notifications.error.title'),
            message: this.$t('notifications.error.message'),
          })
        },
      )
    },

    /**
     * Récupération des fonctions d'une structure
     */
    fetchFonctions() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get('/rest/bd/fonction/structure/' + this.form.structure).then(
        (response) => {
          this.controls.form.fonctionEnable = true
          switch (response.data.length) {
            case 0:
              // Problème configuration => alerte IHM
              this.$notify.error({
                title: this.$t('notifications.noFonction.title'),
                message: this.$t('notifications.noFonction.message'),
              })
              this.form.fonction = null
              this.controls.form.fonctionEnable = false
              break
            case 1:
              // 1 seul élément => sélectionné par défaut
              this.data.fonctions = response.data
              this.form.fonction = response.data[0].id
              break
            default:
              this.form.fonction = null
              this.data.fonctions = response.data
              break
          }
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        (error) => {
          this.$notify.error({
            title: this.$t('notifications.error.title'),
            message: this.$t('notifications.error.message'),
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
      )
    },

    /**
     * Si l'adresse mail est utilisée, impossible de créer user
     */

    checkMail() {
      // Pas de contrôle en dessous de 3 caractères
      if (!this.form.mail || this.form.mail.length < 3) {
        this.controls.form.mail.loading = false
        this.controls.form.mail.available = null
        return
      }
      this.controls.form.mail.loading = true
      this.$axios
        .get('/rest/public/bd/utilisateur/mail', {
          params: {
            mail: this.form.mail,
          },
        })
        .then(
          (response) => {
            if (response.data.mail && response.data.actif) {
              // Déjà utilisé et utilisateur actif
              this.errors.remove('mail')
              const field = this.$validator.fields.find({
                name: 'mail',
                scope: this.$options.scope,
              })
              this.$validator.errors.add({
                id: field.id,
                field: 'mail',
                msg: this.$t('form.champs.mail.label') + ' ' + response.data.mail + ' ' + this.$t('form.champs.mail.used'),
                scope: this.$options.scope,
              })
              this.controls.form.mail.available = null
            }
            // Déjà utilisé et utilisateur inactif
            else if (response.data.mail && !response.data.actif) {
              this.errors.remove('mail')
              const field = this.$validator.fields.find({
                name: 'mail',
                scope: this.$options.scope,
              })
              this.$validator.errors.add({
                id: field.id,
                field: 'mail',
                msg: this.$t('form.champs.mail.inactif'),
                scope: this.$options.scope,
              })
              this.controls.form.mail.available = null
            } else {
              // OK
              this.errors.remove('mail')
              this.controls.form.mail.available = true
            }
            this.controls.form.mail.loading = false
          },
          (error) => {
            this.$notify.error({
              title: this.$t('notifications.error.title'),
              message: this.$t('notifications.error.message'),
            })
            this.controls.form.mail.loading = false
          },
        )
    },

    submitForm() {
      this.$validator.validateAll().then((isValid) => {
        return isValid ? this.save() : null
      })
    },

    /**
     * Submit du register
     */
    submitSubscribtion() {
      this.$validator.validateAll().then((isValid) => {
        // TODO regarder pq l'erreur de l'email se reset
        if (!this.controls.form.mail.available) {
          this.checkMail()
          return null
        }
        return isValid ? this.validateRecaptcha() : null
      })
    },

    /**
     * validation recaptcha
     */
    validateRecaptcha() {
      // 1. si vide rien pas d'appel back utile
      if (!grecaptcha.getResponse()) {
        this.recaptchaCheck = false
        return
      }
      // 2. coché appel back
      this.$axios.get(`/rest/public/bd/utilisateur/validate/captcha?request=${grecaptcha.getResponse()}`)
        .then(response => {
          // si ok => register process
          // sinon errror
          if (response.data.success) {
            this.recaptchaCheck = true
            this.registration()
          } else {
            this.recaptchaCheck = false
          }
        })
        .catch(error => {
          // cocher la case ou erreur technique
          const err = error.response.data
          if (!this.$val.isDefined(err.attributs) && !this.$val.isDefined(err.businessCode)) {
            this.$notify.error({
              title: this.$t('notifications.error.title'),
              message: this.$t('notifications.error.message'),
            })
          } else {
            this.$notify.error({
              title: this.$t('notifications.error.title'),
              message: this.$t('notifications.error.businessCode.' + err.businessCode),
            })
          }
          // qlq soit le cas d'erreur => reset recaptcha
          this.recaptchaCheck = false
          window.grecaptcha.reset()
        })
    },

    /**
     * Fonction d'inscription d'un utilisateur
     */
    registration() {
      const structure = typeof this.form.structure === 'number' ? this.data.structures.find((s) => s.id === this.form.structure) : { nom: this.form.structure }
      const dto = {
        user: {
          mail: this.form.mail,
          nom: this.form.nom,
          prenom: this.form.prenom,
        },
        structure: structure,
      }
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.post('/rest/public/bd/transporteur/inscription', dto)
        .then(response => {
          response.data &&
          this.$notify.success({
            title: this.$t('notifications.succes.title'),
            message: this.$t('notifications.succes.message'),
          })
          this.$router.push('/login')
        })
        .catch(error => {
          // en cas de catch d'erreur on reset le captcha car il sera invalide pour la prochaine tentative de registration
          window.grecaptcha.reset()
          if (this.$val.isEmpty(error.data.attributs) && this.$val.isEmpty(error.data.businessCode)) {
            // A retaper par la suite
            this.$notify.error({
              title: this.$t('notifications.error.title'),
              message: this.$t('notifications.error.message-inscription'),
            })
          } else {
            this.$notify.error({
              title: this.$t('notifications.error.title'),
              message: this.$t('notifications.error.businessCode.' + error.data.businessCode),
            })
          }
        })
        .finally(() => {
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        })
    },

    /**
     * Fonction d'enregistrement des modifications
     */
    save() {
      let parent = this.data.structures.find((structure) => structure.id === this.form.structure)
      // Appel au WS de modif des info utilisateur
      let dto = {
        login: this.form.login,
        nom: this.form.nom,
        prenom: this.form.prenom,
        mail: this.form.mail,
        admin: this.form.admin,
        actif: this.form.actif,
        domain: document.location.origin,
        poste: {
          structure: parent,
          fonction: {
            id: this.form.fonction,
          },
          dateDebut: this.form.datesPoste[0],
          dateFin: this.form.datesPoste[1],
        },
      }
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.post('/rest/bd/utilisateur', dto).then(
        (response) => {
          this.$notify.success({
            title: this.$t('notifications.succes.title'),
            message: this.$t('notifications.succes.message'),
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
          this.reset()
        },
        (error) => {
          if (this.$val.isEmpty(error.data.attributs) && this.$val.isEmpty(error.data.businessCode)) {
            // A retaper par la suite
            this.$notify.error({
              title: this.$t('notifications.error.title'),
              message: this.$t('notifications.error.message'),
            })
          } else {
            this.$notify.error({
              title: this.$t('notifications.error.title'),
              message: this.$t('notifications.error.businessCode.' + error.data.businessCode) + ' ' + error.data.attributs[0],
            })
          }
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
      )
    },
    reset() {
      this.$router.push({
        path: '/pages/user/acces',
      })
    },
    fetchStructuresRegister() {
      this.$axios.get('/rest/public/bd/transporteur/structures')
        .then(response => {
          this.controls.form.structureEnable = true
          this.form.structure = null
          this.data.structures = response.data
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        })
        .catch(error => {
          this.$notify.error({
            title: this.$t('notifications.error.title'),
            message: this.$t('notifications.error.message'),
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        })
    },
    /**
     * Permet de déterminer si le btn de validation doit etre actif ou non
     * @returns {boolean}
     */
    getDisabledBtn() {
      const isUnvalidEmail = !this.controls.form.mail.available
      const isEmptyNomAndPrenom = !this.form.nom && !this.form.prenom
      const isEmptyDatePoste = !this.form.datesPoste && this.logged
      const isNotSameMail = this.form.mail !== this.form.confirmMail
      const isEmptyFonction = !this.form.fonction && this.logged
      const isEmptyStructure = !this.form.structure
      return isUnvalidEmail || isEmptyNomAndPrenom || isEmptyDatePoste || isNotSameMail || isEmptyFonction || isEmptyStructure
    }
  },
}
